<template>
  <article>
    <!-- Card -->
    <v-card class="step-card d-flex flex-column justify-center align-items-center">
      <v-img
        class="step-card__avatar"
        :src="require(`@/assets/images/${icon}.webp`)"
        :width="size.width"
      />
      <v-card-title class="step-card__title pa-0">
        <span class="mx-auto">
          <slot />
        </span>
      </v-card-title>
    </v-card>

    <!-- Disclaimer -->
    <span class="step-card__disclaimer py-4 disclaimer">
      <slot name="disclaimer" />
    </span>
  </article>
</template>

<script>
export default {
    name: "StepCard",
    props: ["icon"],
    computed: {
        size() {
            const xs = {
                height: 144,
                width: 90,
                avatar: 110
            };
            const md = {
                height: 198,
                width: 200,
                avatar: 140
            };
            return this.$vuetify.breakpoint.mdAndUp ? md : xs;
        }
    }
};
</script>
